.tab-panel {
  display: none;
}

.selected-tab-panel {
  display: block;
  background: transparent;
  height: 100%;
  border-top: 1px solid var(--default--border-color--12);
}
